import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import { useEffect, useState } from 'react';
import randomColor from 'randomcolor'
import 'react-big-calendar/lib/css/react-big-calendar.css'

export default function CourseCalendar({ courses }) {
    const [courseList, setCourseList] = useState([])
    const localizer = momentLocalizer(moment)

    const getCourseList = () => {
        let newList = []
        courses.forEach(course => {
            let start_at = new Date(course.start_date)
            let end_at = new Date(course.end_date)
            let color = randomColor({
                luminosity: 'bright',
                format: 'rgb' // e.g. 'rgb(225,200,20)'
             });
            newList.push({ id: course.id, title: course.title, start: start_at, end: end_at, color: color, type: 'course', allDay: 'true' })
        })
        setCourseList(newList)
    }
    useEffect(() => {
        if (courses.length) {
            getCourseList()
        }
        // eslint-disable-next-line
    }, [courses])


    return (
        <Calendar
            localizer={localizer}
            events={courseList}
            startAccessor="start"
            endAccessor="end"
            defaultDate={moment().toDate()}
            eventPropGetter={event => {
                const eventData = courseList.find(ot => ot.id === event.id);
                const backgroundColor = eventData && eventData.color;
                return { style: { backgroundColor } };
            }}
            style={{ minHeight: '100vh', width: '100%' }}
        />

    )
}
